import { useState, useMemo } from 'react';

import {
  PipelineDefinitionOption,
  PipelineVariablesValues,
} from 'src/components/pipelines/components/run-pipeline/types';
import { filterVariables } from 'src/components/pipelines/components/run-pipeline/utils/filterVariables';

export const usePipelineVariables = (
  pipelineDefinitionOption: PipelineDefinitionOption | undefined
) => {
  const [variablesValues, setVariablesValues] =
    useState<PipelineVariablesValues>({});

  const variables = useMemo(
    () => pipelineDefinitionOption?.pipelineDefinition.variables || [],
    [pipelineDefinitionOption]
  );

  const selector = useMemo(
    () =>
      pipelineDefinitionOption
        ? JSON.parse(pipelineDefinitionOption.value)
        : undefined,
    [pipelineDefinitionOption]
  );

  const filteredVariables = useMemo(() => {
    const filteredVariablesArr = filterVariables(variables, variablesValues);
    return filteredVariablesArr.length
      ? {
          variables: filteredVariablesArr,
        }
      : {};
  }, [variables, variablesValues]);

  return {
    variables,
    variablesValues,
    selector,
    setVariablesValues,
    filteredVariables,
  };
};
